import React, { useEffect } from 'react';
import {
  renderCheckboxes,
  renderDropdownWithoutLabel,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import { EmbryologyProfile } from '../EmbryologyProfile';
import { setEmbryologyData } from '../../../../actions/embryologyActions';
import DateComponent from '../../../Registrationform/components/dateComponent';
import { TextField } from '@mui/material';
import { fetchEmbryologySummary } from '../../../../api/embryologyApi';
import dayjs from 'dayjs';
import { toast } from 'sonner';
import CustomTextField from '../../../../common/CustomTextField';
import { CustomTextArea } from '../../../../common/CustomTextArea';

const EmbryologySummary = ({ cycleId, isDisabled }) => {
  const data = useSelector((state) => state.embryologyReducer);
  const summary = useSelector((state) => state.embryologyReducer.summary);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchSummary = async () => {
      const response = await fetchEmbryologySummary(
        data.selectedPatientData.patient.id,
        cycleId,
      );
      if (!response.data.result) {
        return;
      }
      dispatch(setEmbryologyData('summary', response.data.result.summary));
      dispatch(setEmbryologyData('summary.id', response.data.result.id));
      dispatch(setEmbryologyData('summaryId', response.data.result.id));
      toast.success('Data fetched');
    };
    fetchSummary();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (isDisabled) {
      return;
    }

    if (name === 'sourceOfOocyte' && value === 'Self') {
      dispatch(setEmbryologyData('summary.donorName', ''));
      dispatch(setEmbryologyData('summary.donorAge', ''));
      dispatch(setEmbryologyData('summary.donorAadharNumber', ''));
      dispatch(setEmbryologyData('summary.donorMPI', ''));
    }

    if (name === 'sperm' && value === 'Husband') {
      dispatch(setEmbryologyData('summary.donorCode', ''));
      dispatch(setEmbryologyData('summary.donorBank', ''));
    }

    dispatch(setEmbryologyData(`summary.${name}`, value));
  };

  const handleTimeChange = (value, name) => {
    if (isDisabled) {
      return;
    }
    dispatch(setEmbryologyData(`summary.${name}`, value));
  };

  const handleDateChange = (date, name) => {
    if (isDisabled) {
      return;
    }
    const dateString = date ?? '';
    dispatch(setEmbryologyData(`summary.${name}`, dateString));
  };

  const handleRetrievalChange = (e, index) => {
    if (isDisabled) {
      return;
    }
    console.log(e.target.name, e.target.checked);
    const { checked } = e.target;
    const updatedCheckboxes = summary.retrieval.map((item, idx) =>
      idx === index ? { ...item, checked } : item,
    );
    dispatch(setEmbryologyData(`summary.retrieval`, updatedCheckboxes));
  };

  const handleMethodOfPreparationChange = (e, index) => {
    if (isDisabled) {
      return;
    }
    if (e.target.name !== 'otherValue') {
      const { checked } = e.target;
      const updatedCheckboxes = summary.methodOfPreparation.map((item, idx) =>
        idx === index ? { ...item, checked } : item,
      );
      dispatch(
        setEmbryologyData(`summary.methodOfPreparation`, updatedCheckboxes),
      );
    } else {
      dispatch(
        setEmbryologyData(`summary.methodOfPreparationOther`, e.target.value),
      );
    }
  };

  const handleMethodOfFertilizationChange = (e, index) => {
    if (isDisabled) {
      return;
    }
    if (e.target.name !== 'otherValue') {
      const { checked } = e.target;
      const updatedCheckboxes = summary.methodOfFertilization.map(
        (item, idx) => (idx === index ? { ...item, checked } : item),
      );
      dispatch(
        setEmbryologyData(`summary.methodOfFertilization`, updatedCheckboxes),
      );
    } else {
      dispatch(
        setEmbryologyData(`summary.methodOfFertilizationOther`, e.target.value),
      );
    }
  };

  const handleTypesOfICSIChange = (e, index) => {
    if (isDisabled) {
      return;
    }
    if (e.target.name !== 'otherValue') {
      const { checked } = e.target;
      const updatedCheckboxes = summary.typeofICSI.map((item, idx) =>
        idx === index ? { ...item, checked } : item,
      );
      dispatch(setEmbryologyData(`summary.typeofICSI`, updatedCheckboxes));
    } else {
      dispatch(setEmbryologyData(`summary.typeOfICSIOther`, e.target.value));
    }
  };
  return (
    <div className="customer-profile">
      <h3>Gamete & Fertilisation Details</h3>

      <EmbryologyProfile
        isSummary={true}
        handleInputChange={handleInputChange}
      />
      <div className="embryology-table">
        <div className="body" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1, padding: '0px 10px' }}>
            <thead>
              <th>Date:</th>
              <th>
                <DateComponent
                  id="embryologyDate"
                  selectedDate={summary.date ? dayjs(summary.date) : null}
                  handleDateChange={(date, dateString) =>
                    handleDateChange(date, 'date')
                  }
                />
              </th>
            </thead>

            <tbody className="no-border">
              <tr>
                <td>Trigger Time</td>
                <td>
                  <TextField
                    type="time"
                    variant="standard"
                    value={summary.triggerTime}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'triggerTime')
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Time of OPU</td>
                <td>
                  <TextField
                    type="time"
                    variant="standard"
                    value={summary.timeOfOPU}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'timeOfOPU')
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Finishing Time</td>
                <td>
                  <TextField
                    type="time"
                    variant="standard"
                    value={summary.finishingTime}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'finishingTime')
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table style={{ flexGrow: 1 }}>
            <thead>
              <th colSpan={2} style={{ textAlign: 'center' }}>
                <div style={{ height: '41px' }}>ID WITNESSING</div>
              </th>
            </thead>
            <tbody className="no-border">
              <tr>
                <td>Clinician</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'clinician',
                    summary.clinician,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Anaesthetist</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'anaesthetist',
                    summary.anaesthetist,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Embryologist</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'embryologist',
                    summary.embryologist,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Nurse</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'nurse',
                    summary.nurse,
                    handleInputChange,
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="embryology-table">
        <div className="body" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1 }}>
            <thead>
              <th>Source of Oocyte: </th>
              <th>
                {renderDropdownWithoutLabel(
                  'sourceOfOocyte',
                  summary.sourceOfOocyte,
                  ['Self', 'Donor'],
                  handleInputChange,
                )}
              </th>
            </thead>

            <tbody>
              <tr>
                <td>Donor Name</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'donorName',
                    summary.donorName,
                    handleInputChange,
                    false,
                    null,
                    summary.sourceOfOocyte === 'Self',
                  )}
                </td>
              </tr>
              <tr>
                <td>Donor Aadhar Number</td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.donorAadharNumber}
                    name={'donorAadharNumber'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled={summary.sourceOfOocyte === 'Self'}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table style={{ flexGrow: 1 }}>
            <thead>
              <th>Type: </th>
              <th>
                {renderDropdownWithoutLabel(
                  'oocyteType',
                  summary.oocyteType,
                  ['Fresh', 'Frozen'],
                  handleInputChange,
                )}
              </th>
            </thead>
            <tbody>
              <tr>
                <td>Donor Age</td>
                <td>
                  <CustomTextField
                    type="number"
                    style={{ marginBottom: '1px' }}
                    onWheel={(e) => e.target.blur()}
                    value={summary.donorAge}
                    name={'donorAge'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled={summary.sourceOfOocyte === 'Self'}
                  />
                </td>
              </tr>
              <tr>
                <td>Donor MPI</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'donorMPI',
                    summary.donorMPI,
                    handleInputChange,
                    false,
                    null,
                    summary.sourceOfOocyte === 'Self',
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="embryology-table">
        <div className="body">
          Procedure:
          {renderDropdownWithoutLabel(
            'procedure',
            summary.procedure,
            ['IVF', 'ICSI', 'Oocyte Freezing', 'Frozen Oocyte ICSI'],
            handleInputChange,
          )}
        </div>
        <div className="body" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1 }}>
            <thead>
              <th colSpan={2} style={{ textAlign: 'center' }}>
                Oocyte Pickup
              </th>
            </thead>

            <tbody>
              <tr>
                <td>
                  Expected Follicles
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.expectedFollicles}
                    name={'expectedFollicles'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>

                <td>
                  Retrieved OCC
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.retrievedOCC}
                    name={'retrievedOCC'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Emb Sign{' '}
                  {renderInputFieldWithoutLabel(
                    'embSign',
                    summary.embSign,
                    handleInputChange,
                  )}
                </td>
                <td>
                  Witness Sign{' '}
                  {renderInputFieldWithoutLabel(
                    'witnessSign',
                    summary.witnessSign,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Comment:</td>
                <td>
                  <CustomTextArea
                    minRows={2}
                    maxRows={3}
                    value={summary.comment}
                    onChange={handleInputChange}
                    name="comment"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table style={{ flexGrow: 1 }}>
            <thead>
              <th colSpan={4} style={{ textAlign: 'center' }}>
                OCC Denudation
              </th>
            </thead>

            <tbody>
              <tr>
                <td>COC</td>
                <td colspan={3}>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.denudationCoc}
                    name={'denudationCoc'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>MII </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.denudationMii}
                    name={'denudationMii'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>MI </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.denudationMi}
                    name={'denudationMi'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>GV </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.denudationGv}
                    name={'denudationGv'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>Other </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'denudationOther',
                    summary.denudationOther,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Denundation Time </td>
                <td>
                  <TextField
                    type="time"
                    variant="standard"
                    value={summary.denudationTime}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'denudationTime')
                    }
                  />
                </td>
                <td>Denuded By </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'denudedBy',
                    summary.denudedBy,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Oocyte Quality</td>
                <td>
                  {renderDropdownWithoutLabel(
                    'oocyteQuality',
                    summary.oocyteQuality,
                    [' ', 'Good', 'Moderate', 'Poor'],
                    handleInputChange,
                  )}
                </td>
                <td>Witness Sign</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'occDenudationWitness',
                    summary.occDenudationWitness,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Comment</td>
                <td colSpan={3}>
                  <CustomTextArea
                    minRows={2}
                    maxRows={3}
                    value={summary.occDenudationComment}
                    onChange={handleInputChange}
                    name="occDenudationComment"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="embryology-table">
        <div className="body" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1 }}>
            <thead>
              <th colSpan={4} style={{ textAlign: 'center' }}>
                Sperm Preparation
              </th>
            </thead>
            <tbody>
              <tr>
                <td colspan={2}>
                  Sperm
                  {renderDropdownWithoutLabel(
                    'sperm',
                    summary.sperm,
                    [' ', 'Husband', 'Donor'],
                    handleInputChange,
                  )}
                </td>
                <td colspan={2}>
                  Type
                  {renderDropdownWithoutLabel(
                    'spermType',
                    summary.spermType,
                    [' ', 'Fresh', 'Frozen'],
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td colspan={2}>Abstinance (in days)</td>
                <td colspan={2}>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.abstinance}
                    name={'abstinance'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td colspan={2}>
                  Donor Code:
                  {renderInputFieldWithoutLabel(
                    'donorCode',
                    summary.donorCode,
                    handleInputChange,
                    false,
                    null,
                    summary.sperm === 'Husband',
                  )}{' '}
                </td>
                <td colspan={2}>
                  Donor Bank:
                  {renderInputFieldWithoutLabel(
                    'donorBank',
                    summary.donorBank,
                    handleInputChange,
                    false,
                    null,
                    summary.sperm === 'Husband',
                  )}
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  {renderCheckboxes(
                    summary.retrieval.map((item) => item),
                    handleRetrievalChange,
                    'Retrieval',
                    'retrieval',
                    null,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>Time of Sample Collection:</td>
                <td>
                  <TextField
                    type="time"
                    variant="standard"
                    value={summary.timeOfSampleCollection}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'timeOfSampleCollection')
                    }
                  />
                </td>
                <td>Processing Time:</td>
                <td>
                  <TextField
                    type="time"
                    variant="standard"
                    value={summary.processingTime}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'processingTime')
                    }
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  {renderCheckboxes(
                    summary.methodOfPreparation.map((item) => item),
                    handleMethodOfPreparationChange,
                    'Method of Preparation',
                    'methodOfPreparation',
                    summary.methodOfPreparationOther,
                    true,
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          <table style={{ flexGrow: 1 }}>
            <thead>
              <th></th>
              <th>Pre-wash</th>
              <th>Post-wash</th>
            </thead>
            <tbody>
              <tr>
                <td>Volume (mL)</td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.preWash.volume}
                    name={'preWash.volume'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.postWash.volume}
                    name={'postWash.volume'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>Sperm Concen. (million/mL)</td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.preWash.concentration}
                    name={'preWash.concentration'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.postWash.concentration}
                    name={'postWash.concentration'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>Total Motility (%)</td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.preWash.totalMotility}
                    name={'preWash.totalMotility'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.postWash.totalMotility}
                    name={'postWash.totalMotility'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>Prog. Motility (%)</td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.preWash.progressiveMotility}
                    name={'preWash.progressiveMotility'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.postWash.progressiveMotility}
                    name={'postWash.progressiveMotility'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>Morphology</td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.preWash.morphology}
                    name={'preWash.morphology'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.postWash.morphology}
                    name={'postWash.morphology'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>Prepared By</td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'preparedBy',
                    summary.preparedBy,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Witnessed By</td>
                <td colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'witnessedBy',
                    summary.witnessedBy,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Sperm Quality</td>
                <td colSpan={2}>
                  {renderDropdownWithoutLabel(
                    'spermQuality',
                    summary.spermQuality,
                    [' ', 'Good', 'Moderate', 'Poor'],
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Comment</td>
                <td colSpan={2}>
                  <CustomTextArea
                    minRows={2}
                    maxRows={3}
                    value={summary.spermPreparationComment}
                    onChange={handleInputChange}
                    name="spermPreparationComment"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="embryology-table">
        <div className="body">
          {renderCheckboxes(
            summary.methodOfFertilization.map((item) => item),
            handleMethodOfFertilizationChange,
            'Method Of Fertilization',
            'methodOfFertilization',
            summary.methodOfFertilizationOther,
            true,
          )}
        </div>
        <div className="body" style={{ display: 'flex' }}>
          <table style={{ flexGrow: 1 }}>
            <thead>
              <th colSpan={4} style={{ textAlign: 'center' }}>
                ICSI Details
              </th>
            </thead>

            <tbody>
              <tr>
                <td colSpan={2}>COC</td>
                <td colSpan={2}>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.icsiCoc}
                    name={'icsiCoc'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={1}>Types of ICSI</td>
                <td colSpan={3}>
                  {renderCheckboxes(
                    summary.typeofICSI.map((item) => item),
                    handleTypesOfICSIChange,
                    null,
                    'typeofICSI',
                    summary.typeOfICSIOther,
                    true,
                  )}
                </td>
              </tr>
              <tr>
                <td>ICSI MII </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.icsiMii}
                    name={'icsiMii'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>ICSI MI </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.icsiMi}
                    name={'icsiMi'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>ICSI GV </td>
                <td>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.icsiGv}
                    name={'icsiGv'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
                <td>ICSI Other </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'icsiOther',
                    summary.icsiOther,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td colspan={2}>Number of MII Injected</td>
                <td colSpan={2}>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.isciNumberOfMiiInjected}
                    name={'isciNumberOfMiiInjected'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>
              <tr>
                <td>Emb Sign</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'isciEmbSign',
                    summary.isciEmbSign,
                    handleInputChange,
                  )}
                </td>
                <td>Witness Sign</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'isciWitnessSign',
                    summary.isciWitnessSign,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Comment</td>
                <td colSpan={3}>
                  <CustomTextArea
                    minRows={2}
                    maxRows={3}
                    value={summary.isciComment}
                    onChange={handleInputChange}
                    name="isciComment"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table style={{ flexGrow: 1 }}>
            <thead>
              <th colSpan={4} style={{ textAlign: 'center' }}>
                IVF Insemination
              </th>
            </thead>
            <tbody>
              <tr>
                <td>COC</td>
                <td colSpan={3}>
                  <CustomTextField
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={summary.ivfCoc}
                    name={'ivfCoc'}
                    onChange={handleInputChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </td>
              </tr>

              <tr>
                <td colSpan={1}>Insemination Conc.</td>
                <td colSpan={3}>
                  {renderInputFieldWithoutLabel(
                    'inseminationConc',
                    summary.inseminationConc,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Insemination Time</td>
                <td colSpan={3}>
                  <TextField
                    type="time"
                    variant="standard"
                    value={summary.inseminationTime}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'inseminationTime')
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Emb Sign</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'inseminationEmbSign',
                    summary.inseminationEmbSign,
                    handleInputChange,
                  )}
                </td>
                <td>Witness Sign</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'inseminationWitnessSign',
                    summary.inseminationWitnessSign,
                    handleInputChange,
                  )}
                </td>
              </tr>
              <tr>
                <td>Comment</td>
                <td colSpan={3}>
                  <CustomTextArea
                    minRows={2}
                    maxRows={3}
                    value={summary.inseminationComment}
                    onChange={handleInputChange}
                    name="inseminationComment"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EmbryologySummary;
